import { Controller } from "@stimulus/core";
import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Thumbs, Grid, EffectCube } from 'swiper/modules';
import 'swiper/swiper-bundle.min.css';
Swiper.use([Navigation, Pagination, EffectFade, Thumbs, Grid, EffectCube]);

export default class extends Controller {
  connect() {
	const swiper = new Swiper('.swiper0', {
    // modules: [Navigation, Pagination ],
	  direction: 'horizontal',
	  loop: true,
	  speed: 400,
	  breakpoints: {
	    320: {
	      slidesPerView: 1,
	      spaceBetween: 20,
	    },
	    768: {
	      slidesPerView: 1,
	      spaceBetween: 20,
	    }
	  },
	  autoplay: {
	    delay: 3000,
	  },
	  navigation: {
	    nextEl: '.swiper-button-next',
	    prevEl: '.swiper-button-prev',
	  },
	});

  const swiper_ublock = new Swiper('.swiper_ublock', {
    // modules: [Navigation, Pagination ],
	  direction: 'horizontal',
	  loop: true,
	  speed: 400,
	  breakpoints: {
	    320: {
	      slidesPerView: 1,
	      spaceBetween: 20,
	    },
	    768: {
	      slidesPerView: 2,
	      spaceBetween: 20,
	    }
	  },
	  autoplay: {
	    delay: 3000,
	  },
	  navigation: {
	    nextEl: '.swiper-button-next',
	    prevEl: '.swiper-button-prev',
	  },
	});
  const swiper1 = new Swiper('.swiper1', {
    // modules: [Navigation, Pagination ],
	  direction: 'horizontal',
	  loop: true,
	  speed: 400,
	  breakpoints: {
	    320: {
	      slidesPerView: 1,
	      spaceBetween: 20,
	    },
	    768: {
	      slidesPerView: 1,
	      spaceBetween: 20,
	    }
	  },
	  autoplay: {
	    delay: 3000,
	  },
	  navigation: {
	    nextEl: '.swiper-button-next',
	    prevEl: '.swiper-button-prev',
	  },
	});
  }
}
